export default function (props: any) {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M40 24V40C40 41.1046 39.1605 42 38.125 42H11.875C10.8395 42 10 41.1046 10 40V24"
                stroke="#83868A"
                strokeWidth="2.14286"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M28 32H22V42H28V32Z" stroke="#83868A" strokeWidth="2.14286" strokeLinecap="round" strokeLinejoin="round" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20 8H30V18C30 21.3137 27.7614 24 25 24C22.2386 24 20 21.3137 20 18V8Z"
                stroke="#83868A"
                strokeWidth="2.14286"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.7449 8H20V17C20 20.866 16.7518 24 12.7449 24C10.1244 24 8 21.9503 8 19.4219C8 18.7903 8.13545 18.1655 8.39783 17.5869L12.7449 8Z"
                stroke="#83868A"
                strokeWidth="2.14286"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M30 8H37.2543L41.601 17.5869C42.6513 19.9033 41.5566 22.6027 39.156 23.6162C38.5563 23.8693 37.9089 24 37.2543 24C33.2479 24 30 20.866 30 17V8Z"
                stroke="#83868A"
                strokeWidth="2.14286"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
